import React from "react";
import SharedDashboard from "../../../common/components/shared-dashboard/shared-dashboard";

const Dashboard: React.FC = () => {
  return <SharedDashboard mode="preNeed" />;
};
export default Dashboard;